import { StateCreator, create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface GoogleMapLocationStore {
  searchString: string
  setSearchString: (value: string) => void
  country: string
  setCountry: (value: string) => void
  placeId: string
  setPlaceId: (value: string) => void
}

const getGoogleMapLocationStore = (
  set: (fn: (state: GoogleMapLocationStore) => GoogleMapLocationStore) => void
) => ({
  placeId: '',
  setPlaceId: (value: string) => {
    set((state: GoogleMapLocationStore) => ({
      ...state,
      placeId: value,
    }))
  },
  searchString: '',
  setSearchString: (value: string) => {
    set((state: GoogleMapLocationStore) => ({
      ...state,
      searchString: value,
    }))
  },
  country: '',
  setCountry: (value: string) => {
    set((state: GoogleMapLocationStore) => ({
      ...state,
      country: value,
    }))
  },
})

const useGoogleMapLocationStore = create<GoogleMapLocationStore>()(
  devtools(
    getGoogleMapLocationStore as StateCreator<
      GoogleMapLocationStore,
      [['zustand/devtools', never]],
      [],
      GoogleMapLocationStore
    >
  )
)
export default useGoogleMapLocationStore
